import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { extendedServiceStopStatuses } from 'types/timetableServices';
import { formatTime } from 'utils/dates';

import { TimetableDetailTime, TimetableDetailData } from './StopsSummary.style';

const StopDeparture = ({ extendedDepartureStatus, departureDateTime, commercialDepartureDateTime, scheduledDepartureDateTime }) => {
  const commercialDepartureTime = formatTime(commercialDepartureDateTime);
  const scheduledDepartureTime = formatTime(scheduledDepartureDateTime);
  const departureTime = formatTime(departureDateTime);

  switch (extendedDepartureStatus) {
    case extendedServiceStopStatuses.CANCELLED:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <FormattedMessage id="journeySegment.timetableDepartureCancelled" />
        </TimetableDetailTime>
      );
    case extendedServiceStopStatuses.DEPARTED:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <FormattedMessage id="journeySegment.timetableDeparted" /> {departureTime}
        </TimetableDetailTime>
      );
    case extendedServiceStopStatuses.DEPARTED_ON_TIME:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <FormattedMessage id="journeySegment.timetableDepartedOnTime" /> {departureTime}
        </TimetableDetailTime>
      );
    case extendedServiceStopStatuses.DEPARTED_LATE:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <TimetableDetailData status={extendedDepartureStatus}>{commercialDepartureTime || scheduledDepartureTime}</TimetableDetailData>
          <FormattedMessage id="journeySegment.timetableDepartedAt" values={{ time: departureTime }} />
        </TimetableDetailTime>
      );
    case extendedServiceStopStatuses.DEPARTED_EXPECTED_LATE:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <TimetableDetailData status={extendedDepartureStatus}>{commercialDepartureTime || scheduledDepartureTime}</TimetableDetailData>
          <FormattedMessage id="journeySegment.timetableDepartedExpectedAt" values={{ time: departureTime }} />
        </TimetableDetailTime>
      );
    case extendedServiceStopStatuses.EXPECTED:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <TimetableDetailData status={extendedDepartureStatus}>{commercialDepartureTime || scheduledDepartureTime}</TimetableDetailData>
          <FormattedMessage id="journeySegment.timetableExpectedAt" values={{ time: departureTime }} />
        </TimetableDetailTime>
      );
    default:
      return (
        <TimetableDetailTime status={extendedDepartureStatus}>
          <FormattedMessage id="journeySegment.timetableDeparts" /> {commercialDepartureTime || scheduledDepartureTime}
        </TimetableDetailTime>
      );
  }
};

StopDeparture.propTypes = {
  commercialDepartureDateTime: PropTypes.instanceOf(Date),
  departureDateTime: PropTypes.instanceOf(Date),
  extendedDepartureStatus: PropTypes.oneOf(Object.keys(extendedServiceStopStatuses)),
  scheduledDepartureDateTime: PropTypes.instanceOf(Date)
};

export default injectIntl(StopDeparture);
